// extracted by mini-css-extract-plugin
export default {"title":"Categories_title__MZvmY","more":"Categories_more__9n5Yz","filters":"Categories_filters__+6Bkq","filter":"Categories_filter__Z6N3Q","back":"Categories_back__zT+mj"};